import { useImportJson } from "@/playback-controls/hooks/useImportJson";
import { UploadIcon } from "@radix-ui/react-icons";
import { IconButton, Tooltip } from "@radix-ui/themes";
import dayjs from "dayjs";
import { ChangeEvent, useRef } from "react";
import { toast } from "react-hot-toast";

type ImportPreset = { start_time: string; end_time: string; name: string };

export function ImportJsonPresets({
  onSave,
}: {
  onSave?: (
    value: {
      value: string;
      label: string;
    }[]
  ) => void;
}) {
  const inputRef = useRef<HTMLInputElement | null>(null);
  const importJson = useImportJson();

  const onImport = () => {
    inputRef.current?.click();
  };

  const generateLabel = (range: ImportPreset) =>
    `${dayjs(range.start_time).format("MMM DD, HH:mm:ss")} - ${dayjs(
      range.end_time
    ).format("HH:mm:ss")}`;

  const savePreset = (value: ImportPreset[]) => {
    const formattedPresets = value.map((range) => ({
      value: [range.start_time, range.end_time].join("__"),
      label: range.name || generateLabel(range),
    }));

    onSave?.(formattedPresets);

    toast.success("Daterange presets imported successfully");
  };

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;

    importJson(e.target.files[0]).then((value) => {
      savePreset(value);
    });
  };

  return (
    <div className="flex">
      <Tooltip content="Import from JSON">
        <IconButton
          onClick={onImport}
          size="3"
          variant="soft"
          color="gray"
          // className="flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-md grow-1 min-w-8 w-8 h-8"
        >
          <UploadIcon width={18} height={18} />
        </IconButton>
      </Tooltip>
      <input
        ref={inputRef}
        onChange={onChange}
        className="min-h-0 h-0 max-h-0 invisible overflow-hidden w-0"
        type="file"
        multiple={false}
        accept=".json"
      />
    </div>
  );
}
